import { BaseCoreState, baseSharedActions } from '../../_store';
import { BaseToastAlertClasses } from '../../shared/enums/base-toast-alert-classes.enum';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class BaseAssignmentsHelpersService {
  constructor(private store: Store<BaseCoreState>, private translateService: TranslateService) {}

  showNotDownloadedContractsAlert(profiles: string[]): void {
    const profilesNames = profiles.join(', ');
    const noContractProfilesAlert = `
                  <p>${this.translateService.instant('externalEmployees.contractsNotDownloaded')}</p>
                  <span>${profilesNames}</span></p>
                `;
    this.store.dispatch(
      baseSharedActions.addSystemAlert({
        payload: {
          class: BaseToastAlertClasses.error,
          body: noContractProfilesAlert,
          closeManually: true,
        },
      })
    );
  }
}
